import React from "react";
import { Helmet } from "react-helmet";

const MetaTags = ({
  title,
  type,
  siteName,
  url,
  keywords,
  description,
  revisitAfter,
}) => {
  return (
    <Helmet>
      <title>{title}</title>
      <link rel="canonical" href={url} />
      <meta property="og:title" content={title} />
      <meta property="og:type" content={type} />
      <meta property="og:site_name" content={siteName} />
      <meta property="og:url" content={url} />
      <meta property="og:image" content="https://cmcracker.in/storelogo.png" />
      <meta name="keywords" content={keywords} />
      <meta
        property="og:description"
        name="description"
        content={description}
      />
      <meta name="twitter:card" content="summary_large_image" />
      <meta name="twitter:domain" content="cmcracker.in" />
      <meta name="twitter:url" content={url} />
      <meta name="twitter:title" content={title} />
      <meta name="twitter:description" content={description} />
      <meta name="twitter:image" content="https://cmcracker.in/storelogo.png" />
      <meta name="robots" content="index, follow" />
      <meta name="revisit-after" content={revisitAfter} />
      <meta name="copyright" content="CM CRACKERS" />
      <meta name="language" content="English" />
      <meta name="distribution" content="Global" />
    </Helmet>
  );
};

export default MetaTags;
